var currentPicker;

       function openDrawer(picker, contentText, choose_set) {
            currentPicker = picker;
            $('#drawer-content-free').text(contentText);
            $('#drawer-content-free').attr('choose_set', choose_set);
            $('.custom-drawer-overlay-two').fadeIn();
            $('.custom-drawer-two').animate({ 'right': '0' }, 300).show();
           // $('html').css('overflow-y', "hidden");
       }

       function openDrawerTwo(picker, contentText) {
             currentPicker = picker;
             $('#drawer-content').text(contentText);
             $('.custom-drawer-overlay').fadeIn();
             $('.custom-drawer').animate({ 'right': '0' }, 300).show();
        }

    function checkProductPickers() {
        var allHaveImages = true;
        $('.ps-color-option-main .product-picker').each(function() {
            if ($(this).find('img').length === 0) {
                allHaveImages = false;
                $('.color-option-addtocart-btn').text('Scegli ' + $(this).siblings('.product-option-label').text());
                return false;
            }
        });

        if (allHaveImages) {
            $('.color-option-addtocart-btn').show();
            $('.product-addtocart-btn-main').show();
        } else {
            $('.color-option-addtocart-btn').show();
            $('.product-addtocart-btn-main').show();
        }
    }

function checkAndAddProductPickerTwo() {
    if ($('.product-picker-col-two').length === 0) {
        var newPickerTwo = `
            <div class="product-picker-col-two">
                <div class="product-picker-two">
                    <div class="product-picker-two-discount">
                        <span>-50%</span>
                    </div>
                    <span class="product-picker-two-plus-icon">
                        <svg width="13" height="13" viewBox="0 0 10 10" fill="none">
                            <path d="M5 0.5V9.5M9.5 5H0.5" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </span>
                </div>
                <span class="product-option-label-two">Opzionale Design</span>
            </div>
        `;
        $('.product-picker-option-two').append(newPickerTwo);
    }
}

    checkProductPickers();
    $(document).on('click', '.product-picker', function(e) {
          if ($(e.target).hasClass('remove-btn')) {
              return; // Exit the function if the clicked element has the class 'remove-btn'
          }
      openDrawer($(this), $(this).siblings('.product-option-label').text(), $(this).closest(".product-picker-col").attr('choose_set'));
          // Handle click on .product-picker here
      });
          

      $('.product-picker-two').click(function(event) {
            if ($(event.target).hasClass('remove-btn')) {
                return;
            }
            openDrawerTwo($(this), $(this).siblings('.product-option-label-two').text());
        });


     
    $(document).on('click', '.product-picker-two', function(event) {
        if ($(event.target).hasClass('remove-btn')) {
            return;
        }
       openDrawerTwo($(this), $(this).siblings('.product-option-label-two').text());
    });

    $('.color-option-addtocart-btn').click(function() {
        var missingLabels = [];
        var firstMissingPicker = null;

        $('.product-picker').each(function() {
            if ($(this).find('img').length === 0) {
                var labelText = $(this).siblings('.product-option-label').text();
                var label_picker_btn = $(this).closest('.product-picker-col').attr('p_text', labelText);
                
                missingLabels.push(labelText);
                if (!firstMissingPicker) {
                    firstMissingPicker = $(this);
                }
            }
        });

        if (firstMissingPicker) {
            openDrawer(firstMissingPicker, firstMissingPicker.siblings('.product-option-label').text());
        } else {
            var firstPicker = $('.product-picker').first();
            openDrawer(firstPicker, firstPicker.siblings('.product-option-label').text());
        }
    });

    function closeDrawer() {
        $('.custom-drawer-overlay').fadeOut();
        $('.custom-drawer').animate({ 'right': '-360px' }, 300, function() {
            $(this).hide();
        });
        $('.custom-drawer-overlay-two').fadeOut();
        $('.custom-drawer-two').animate({ 'right': '-360px' }, 300, function() {
            $(this).hide();
        }); 
        $('html').css('overflow-y', "auto");
    }

    $('.custom-drawer-overlay, .custom-drawer-overlay-two, .drawer-close').click(function() {
        closeDrawer();
    });

    $('.drawer-product-options img').click(function() {
        var imgSrc = $(this).attr('src');
        var titleText = $(this).siblings('.drawer-product-title').text();
        var drawerpickerid = $("#drawer-content-free").attr("picker-id");
        var mainpickerid =  $(".product-picker-col").attr("id");
        var productId = $(this).parent().data('product-id');
        var productTitle = $(this).parent().data('product-title');
        var productImage = $(this).parent().data('product-quantity');
                var newQuantity = productImage - 1;
        $(this).parent().attr('data-product-quantity', newQuantity);

        if (newQuantity <= 0) {
            $(this).parent().addClass('p-soldout');
            $(this).parent().append('<div class="drawer-product-soldout">Sold Out</div>');
        }

       
        closeDrawer();
        if (!currentPicker) {
    console.warn("currentPicker is undefined!");
    return;
}
currentPicker.empty();
        currentPicker.append(`<img src="${imgSrc}" alt="" />`);
        currentPicker.append('<button class="remove-btn">X</button>');
        currentPicker.css('border', 'none');

        var parentCol = currentPicker.closest('.product-picker-col, .product-picker-col-two');
        parentCol.attr('data-product-id', productId);
        parentCol.attr('data-product-title', productTitle);
        parentCol.attr('data-product-quantity', productImage);

        

        if (currentPicker.hasClass('product-picker-two')) {
            currentPicker.siblings('.product-option-label-two').text(titleText);
        } else {
            currentPicker.siblings('.product-option-label').text(titleText);
        }
      
        checkProductPickers();
        if (currentPicker.hasClass('product-picker-two')) {
            checkAndAddProductPickerTwo();
        }
    });


    // $(document).on('click', '.remove-btn', function(event) {
    //     event.stopPropagation();
    //     var pickerCol = $(this).closest('.product-picker-col-two');
    //     var pickerCol3 =  $(this).closest('.product-picker-col');
    //     currentPicker.css('border', '1px solid #9e9e9e');
    //     $('.product-picker').css('border', '1px solid #9e9e9e');
    //     var productId = pickerCol.data('product-id') || pickerCol3.data('product-id');
    //     var productQuantity;
 
    //       // var productId = pickerCol3.data('product-id');
    //       // var productCol = $(`[data-product-id="${productId}"]`);
    //       // var productQuantity = productCol.data('product-quantity');
    //       // productCol.attr('data-product-quantity', productQuantity);
    //       // if (productQuantity > 0) {
    //       //     productCol.removeClass('p-soldout');
    //       //     productCol.find('.drawer-product-soldout').remove();
    //       // }
    //     if (productId) {
    //     $('.drawer-product-options').each(function() {
    //         if ($(this).data('product-id') === productId) {
    //             productQuantity = $(this).data('product-quantity');
    //             $(this).data('product-quantity', productQuantity + 1);
    //             $(this).attr('data-product-quantity', productQuantity + 1);
    //             if (productQuantity + 1 > 0) {
    //                 $(this).removeClass('p-soldout');
    //                 $(this).find('.drawer-product-soldout').remove();
    //             }
    //         }
    //     });
    //   }


    //     pickerCol.removeAttr('data-product-id data-product-title data-product-quantity');
    //     pickerCol3.removeAttr('data-product-id data-product-title data-product-quantity');
    //     if (pickerCol.length) {
    //     pickerCol.remove();
    //     // var picker1 = $(this).closest('.product-picker-two');
    //     // var label_picker1 = $(this).closest('.product-picker-col-two').attr('p_text');
    //     // let Dlength = 0;
          
    //     // const element1 = document.querySelectorAll('.product-picker-col');
    //     //   element1.forEach((element1, index) => {
    //     //   Dlength += 1;
    //     //   });
            
    //     // const elements = document.querySelectorAll('.product-picker-col-two');
    //     //   elements.forEach((element, index) => {
    //     //   Dlength += 1;
    //     //   if (index === elements.length - 1) {  // Check if it's the last element
    //     //       var newdesign = Dlength - 1;
    //     //     $('.product-picker-col-two:last-child .product-option-label-two').text('Design 0' + newdesign);
    //     //   }
    //     // });
    //     picker.siblings('.product-option-label-two').text('Design');
    //     } else {
    //         var picker = $(this).closest('.product-picker');
    //         var label_picker = $(this).closest('.product-picker-col').attr('p_text');
    //         picker.empty();
    //         picker.append(`
    //             <span class="product-picker-plus-icon">
    //                 <svg class="" width="13" height="13" viewBox="0 0 10 10" fill="none">
    //                     <path d="M5 0.5V9.5M9.5 5H0.5" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"></path>
    //                 </svg>
    //             </span>
    //         `);
    //         picker.siblings('.product-option-label').text(label_picker);
    //     }
    //   checkProductPickers();
    // });
 
 
 $(document).on('click', '.remove-btn', function(event) {
        event.stopPropagation();
        var pickerCol = $(this).closest('.product-picker-col-two');
        var pickerCol3 =  $(this).closest('.product-picker-col');
        currentPicker.css('border', '1px solid #9e9e9e');
        $('.product-picker').css('border', '1px solid #9e9e9e');
       var productId = pickerCol.data('product-id') || pickerCol3.data('product-id');
       var productQuantity;

      // Restore the data-product-quantity in .drawer-product-options
    if (productId) {
        $('.drawer-product-options').each(function() {
            if ($(this).data('product-id') === productId) {
                productQuantity = $(this).data('product-quantity');
                $(this).data('product-quantity', productQuantity + 1);
                $(this).attr('data-product-quantity', productQuantity + 1);
                if (productQuantity + 1 > 0) {
                    $(this).removeClass('p-soldout');
                    $(this).find('.drawer-product-soldout').remove();
                }
            }
        });
    }



        pickerCol.removeAttr('data-product-id data-product-title data-product-quantity');
        pickerCol3.removeAttr('data-product-id data-product-title data-product-quantity');
        if (pickerCol.length) {
            pickerCol.remove();
        } else {
            var picker = $(this).closest('.product-picker');
            var label_picker = $(this).closest('.product-picker-col').attr('p_text');
            picker.empty();
            picker.append(`
                <span class="product-picker-plus-icon">
                    <svg class="" width="13" height="13" viewBox="0 0 10 10" fill="none">
                        <path d="M5 0.5V9.5M9.5 5H0.5" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </span>
            `);
            picker.siblings('.product-option-label').text(label_picker);
        }
        checkProductPickers();
    });
 
 
    $('.product-picker').each(function() {
        $(this).data('original-label', $(this).siblings('.product-option-label').text());
    });

    $('.product-picker-two').each(function() {
        $(this).data('original-label-two', $(this).siblings('.product-option-label-two').text());
    });
    checkAndAddProductPickerTwo();

  // -------------------------
// Helper: Check if any bundle product is selected
function hasSelectedBundleProducts() {
    let selected = false;
    $('.product-picker-col, .product-picker-col-two').each(function() {
        if ($(this).find('img').length > 0) {
            selected = true;
            return false; // exit loop
        }
    });
    return selected;
}

// -------------------------
// Enable/disable main product button
function updateMainProductButton() {
    const mainBtn = $('.product-addtocart-btn-main');
    if (hasSelectedBundleProducts()) {
        mainBtn.css({
            'pointer-events': 'auto',
            'opacity': '1',
            'display': 'block'
        });
    } else {
        mainBtn.css({
            'pointer-events': 'none',
            'opacity': '0.5',
            'display': 'none'
        });
    }
}



// $('#add-all-to-cart').on('click', function() {
//     $("#loadingImage").show();
//     let randomNumber = Math.floor(Math.random() * 10000);
//     let timestamp = new Date().getTime();
//     let uniqueNumber = timestamp.toString() + randomNumber.toString();
//     let mainProductId = $('#mainProductId').val();
//     $("#groupid").val(uniqueNumber);

//     var delay = 100;

//     function addProductsToCart(products, index, callback) {
//         if (index >= products.length) {
//             callback();
//             return;
//         }

//         let productId = $(products[index]).attr('data-product-id');
//         if (!productId) {
//             // Skip if no product selected
//             addProductsToCart(products, index + 1, callback);
//             return;
//         }

//         let properties = { bundleid: uniqueNumber, };

//         $.ajax({
//             url: '/cart/add.js',
//             method: 'POST',
//             dataType: 'json',
//             contentType: 'application/json',
//             data: JSON.stringify({
//                 id: productId,
//                 quantity: 1,
//                 properties: properties
//             }),
//             success: function(data) {
//                 setTimeout(function() {
//                     addProductsToCart(products, index + 1, callback);
//                 }, delay);

//                     $.ajax({
//                     type: 'POST',
//                     url: '/cart/add.js',
//                     data: {
//                     quantity: 1,
//                     id: mainProductId
//                     },
//                     dataType: 'json', 
//                     success: function (data) { 
                    
//                     } 

//             },
//             error: function(error) {
//                 console.error('Error adding product ' + productId + ' to cart:', error);
//                 setTimeout(function() {
//                     addProductsToCart(products, index + 1, callback);
//                 }, delay);
//             }
//         });
//     }

//     // Create static arrays of selected pickers only
//     var selectedProducts1 = $('.product-picker-col').filter(function() { return $(this).find('img').length > 0; });
//     var selectedProducts2 = $('.product-picker-col-two').filter(function() { return $(this).find('img').length > 0; });
//     var selectedProducts3 = $('.product-picker-col-three').filter(function() { return $(this).find('img').length > 0; });

//     function submitForm() {
//         $("#loadingImage").hide();
//         $(".form_class").submit();
//     }

//     // Add in proper sequence: two → three → main
//     addProductsToCart(selectedProducts2, 0, function() {
//         addProductsToCart(selectedProducts3, 0, function() {
//             addProductsToCart(selectedProducts1, 0, submitForm);
//         });
//     });
// });


// $('#add-all-to-cart').on('click', function() {
//     $("#loadingImage").show();
//     // let randomNumber = Math.floor(Math.random() * 10000);
//     // let timestamp = new Date().getTime();
//     // let uniqueNumber = timestamp.toString() + randomNumber.toString();
//     // $("#groupid").val(uniqueNumber);

//     var delay = 100;

//     function addProductsToCart(products, index, callback) {
//         if (index >= products.length) {
//             callback();
//             return;
//         }

//         let productId = $(products[index]).attr('data-product-id');
//         if (!productId) {
//             // Skip if no product selected
//             addProductsToCart(products, index + 1, callback);
//             return;
//         }

//         // let properties = { bundleid: uniqueNumber };

//         $.ajax({
//             url: '/cart/add.js',
//             method: 'POST',
//             dataType: 'json',
//             contentType: 'application/json',
//             data: JSON.stringify({
//                 id: productId,
//                 quantity: 1
//             }),
//             success: function(data) {
//                 setTimeout(function() {
//                     addProductsToCart(products, index + 1, callback);
//                 }, delay);
//             },
//             error: function(error) {
//                 console.error('Error adding product ' + productId + ' to cart:', error);
//                 // setTimeout(function() {
//                 //     addProductsToCart(products, index + 1, callback);
//                 // }, delay);
//             }
//         });
//     }

//     // Create static arrays of selected pickers only
//     var selectedProducts1 = $('.product-picker-col').filter(function() { return $(this).find('img').length > 0; });
//     var selectedProducts2 = $('.product-picker-col-two').filter(function() { return $(this).find('img').length > 0; });
//     var selectedProducts3 = $('.product-picker-col-three').filter(function() { return $(this).find('img').length > 0; });

//     function submitForm() {
//         $("#loadingImage").hide();
//         // $("#product-form-template--25805423739206__main").submit();
//         $('.ps-btn').click();
//     }

//     // Add in proper sequence: two → three → main → one
//     addProductsToCart(selectedProducts2, 0, function() {
//         addProductsToCart(selectedProducts3, 0, function() {
//             addProductsToCart(selectedProducts1, 0, submitForm);
//         });
//     });
// });




function addProductsToCart(products, index = 0, done) {
  if (index >= products.length) {
    if (done) done();
    return;
  }

  let productId = $(products[index]).data('product-id');
  if (!productId) {
    console.warn('Missing product ID for', products[index]);
    addProductsToCart(products, index + 1, done);
    return;
  }

  $.ajax({
    url: '/cart/add.js',
    method: 'POST',
    dataType: 'json',
    data: { id: productId, quantity: 1 },
    success: function() {
      console.log('Added product:', productId);
      addProductsToCart(products, index + 1, done);
    },
    error: function(err) {
      console.error('Error adding', productId, err);
      addProductsToCart(products, index + 1, done);
    }
  });
}

$('#add-all-to-cart').off('click').on('click', function() {
  let products = $('.product-picker-col[data-product-id]');
  if (!products.length) return alert('Please select all products first.');

  $(this).prop('disabled', true).text('Adding...');
  addProductsToCart(products, 0, function() {
    $('#add-all-to-cart').prop('disabled', false).text('Add All to Cart');
$('.ps-btn:visible:first').click();

  });
});



$('#CartDrawer-Overlay').on('click', function() {
    $('.product-addtocart-btn-main').removeAttr("style");
    $("#loadingImage").hide();
});

$(".product-color").each(function(){
        var colorOptionlabel = $('.selected span').text();
        var choose_set_option =  $(".selected").attr('id');
        $('.product-picker-col').attr('choose_set', choose_set_option);
        $('.color-option-addtocart-btn').attr('choose_set', choose_set_option);
        
        // if (colorOptionlabel === 'Premium kit (4 Colori)' ) {
        //      $('.ps-color-option-three-main .ps-color-option-three-label').text('');
        //      $('.ps-color-option-three-main .ps-color-option-three-label').append('04 | Inclusi nel Set');
        //      $('.product-picker-option-three').css('display', 'none');
        //      $('.single_included_set_main').css('display', 'flex'); 
        //      $('.product-picker-option-three').find('.product-picker-col-three').removeClass("product-picker-col-three");
        //      $('.single_included_set').find('[data-product-id]').addClass("product-picker-col-three");
        // }
        
        
        // if (colorOptionlabel === '1 Confezione di Gelly' || colorOptionlabel === '2 Confezioni di Gelly') {
        //         $('.ps-color-option-two-desktop').css('display', 'none');
        //   }else{
        //         $('.ps-color-option-two-desktop').css('display', 'block');     
        //   }   

        // if (colorOptionlabel === '1 Confezione di Gelly' || colorOptionlabel === '2 Confezioni di Gelly' || colorOptionlabel === '3 Confezioni di Gelly') {
        //         $('.ps-color-option-three-main').css('display', 'none');
        //         $('.ps-color-optionable').css('display', 'grid');  
        //   }else{
        //         // $('.ps-color-option-three-main').css('display', 'grid');
        //         // $('.ps-color-optionable').css('display', 'none');     
        //   }
          
        // if (colorOptionlabel === 'Vanity Kit (5 colori)' ) {
        //         $('.ps-color-option-three-main .ps-color-option-three-label').text('');
        //         $('.ps-color-option-three-main .ps-color-option-three-label').append('04 | Aggiungi accessori (facoltativo)');
        //         $('.ps-color-option-three-main').css('display', 'none');
        //         $('.ps-color-optionable').css('display', 'grid');
        //           setTimeout(function() {
        //         $('.product-picker-option-three').find('.product-picker-col-three').removeClass("product-picker-col-three");
        //           }, 1000);
        //   }

  
      // if(colorOptionlabel === 'Starter kit (3 Colori)') {
      //     $('.product-picker-option-three').css('display', 'none');
      //     $('.single_included_set_main').css('display', 'flex');
      //     $('.product-picker-option-three').find('.product-picker-col-three').removeClass("product-picker-col-three");
          
      // }else {
      //     $('.product-picker-option-three').css('display', 'flex');
      //     $('.single_included_set_main').css('display', 'none');
         
      // }
       
        // setTimeout(function() {
        //   $('.product-color-option-section .selected').click();
        // }, 500);

  
    //  $(this).click(function(){
    //    $(".product-color").removeClass("selected");
    //     $(this).addClass("selected");
    //     var colorOptionValue = $(".selected").attr('boxlimit');
    //     var colorOptionlabel = $('.selected span').text();
    //     var choose_set_option =  $(".selected").attr('id');
    //     $('.color-option-addtocart-btn').attr('choose_set', choose_set_option);
        
    //     // Abhishek 
        
    //             // if ($('.product-addtocart-btn-main').attr('style') === '') {
    //             //     window.location.reload();
    //             // }
                
    //             // if ($('.product-addtocart-btn-main').attr('style') === '') {
    //             //     checkProductPickers();
    //             // }
              
    //             var $select = $('.gf_variants');
    //             $select.find('option').each(function() {
    //                 if ($(this).text() === colorOptionlabel) {
    //                     $select.val($(this).val()).trigger('change');
    //                     $select.focus().blur();
    //                     return false; // Break the each loop
    //                 }
    //             });
                
    //             var p_price = $('.gf_product-price').text();
    //             var p_compare_price = $('.gf_product-compare-price').text();
    //             $('.ProductMeta__Price').text(p_price);
    //             $('.Price--compareAt').text(p_compare_price);
                
                
    //     //       if (colorOptionlabel === '1 Confezione di Gelly' || colorOptionlabel === '2 Confezioni di Gelly' || colorOptionlabel === 'Starter kit (3 Colori)' || colorOptionlabel === 'Premium kit (4 Colori)') {
    //     //          $('.ps-color-option-two-desktop').css('display', 'none');
    //     //    }else{
    //     //          $('.ps-color-option-two-desktop').css('display', 'block');     
    //     //    }
           
           
    //     //   if (colorOptionlabel === '3 Confezioni di Gelly') {
    //     //       $('.ps-color-option-three-main').css('display', 'none');
    //     //       $('.ps-color-optionable').css('display', 'grid');
    //     //       $('.ps-color-optionable .ps-color-option-three-label').text('');
    //     //       $('.ps-color-optionable .ps-color-option-three-label').append('04 | Aggiungi accessori (facoltativo)');
    //     //       $('.product-picker-option-three').find('.product-picker-col-three').removeClass("product-picker-col-three");
    //     //       $('.single_included_set').find('.product-picker-col-three').removeClass("product-picker-col-three");
    //     //   }
           
           
    //     //   if (colorOptionlabel === 'Premium kit (4 Colori)' ) {
    //     //      $('.ps-color-option-three-main .ps-color-option-three-label').text('');
    //     //      $('.ps-color-option-three-main .ps-color-option-three-label').append('03 | Inclusi nel Set');
    //     //      $('.product-picker-option-three').css('display', 'none');
    //     //      $('.single_included_set_main').css('display', 'flex'); 
    //     //      $('.product-picker-option-three').find('.product-picker-col-three').removeClass("product-picker-col-three");
    //     //      $('.single_included_set').find('[data-product-id]').addClass("product-picker-col-three");
    //     //      $('.ps-color-optionable').css('display', 'none');
    //     //      $('.ps-color-option-three-main').css('display', 'grid');
    //     //   }
          
    //     //   if (colorOptionlabel === 'Vanity Kit (5 colori)' ) {
    //     //      $('.ps-color-option-three-main .ps-color-option-three-label').text('');
    //     //      $('.ps-color-option-three-main .ps-color-option-three-label').append('04 | Inclusi nel Set');
    //     //      $('.product-picker-option-three').css('display', 'flex');
    //     //      $('.single_included_set_main').css('display', 'none'); 
    //     //      $('.single_included_set').find('.product-picker-col-three').removeClass("product-picker-col-three");
    //     //      $('.product-picker-option-three').find('[data-product-id]').addClass("product-picker-col-three");
    //     //      $('.ps-color-optionable').css('display', 'none');
    //     //      $('.ps-color-option-three-main').css('display', 'grid');
    //     //   }
           
         
           
    //   //     if (colorOptionlabel === '1 Confezione di Gelly' || colorOptionlabel === '2 Confezioni di Gelly' ) {
    //   //           $('.ps-color-optionable .ps-color-option-three-label').text('');
    //   //           $('.ps-color-optionable .ps-color-option-three-label').append('03 | Aggiungi accessori (facoltativo)');
    //   //     }
           
    //   //     if (colorOptionlabel === 'Starter kit (3 Colori)' || colorOptionlabel === 'Premium kit (4 Colori)' ) {
    //   //           $('.ps-color-option-three-main .ps-color-option-three-label').text('');
    //   //           $('.ps-color-option-three-main .ps-color-option-three-label').append('03 | Inclusi nel Set');
    //   //     }
           
    //   //     if (colorOptionlabel === 'Premium kit (4 Colori)' ) {
    //   //           $('.ps-color-option-three-main').css('display', 'grid');
    //   //           $('.ps-color-optionable').css('display', 'none');   
    //   //     }
           
    //   //     if (colorOptionlabel === 'Vanity Kit (5 colori)' ) {
    //   //           $('.ps-color-option-three-main .ps-color-option-three-label').text('');
    //   //           $('.ps-color-option-three-main .ps-color-option-three-label').append('04 | Aggiungi accessori (facoltativo)');
    //   //           // $('.ps-color-option-three-main').css('display', 'none');
    //   //           // $('.ps-color-optionable').css('display', 'grid');
    //   //           // setTimeout(function() {
    //   //           // $('.product-picker-option-three').find('.product-picker-col-three').removeClass("product-picker-col-three");
    //   //           //   }, 1000);
    //   //     }
     

    //   //     if (colorOptionlabel === '1 Confezione di Gelly' || colorOptionlabel === '2 Confezioni di Gelly' || colorOptionlabel === '3 Confezioni di Gelly') {
    //   //           $('.ps-color-option-three-main').css('display', 'none');
    //   //           $('.ps-color-optionable').css('display', 'grid');  
    //   //     }else{
    //   //           // $('.ps-color-option-three-main').css('display', 'grid');
    //   //           // $('.ps-color-optionable').css('display', 'none');     
    //   //     }

    //   //   if(colorOptionlabel === 'Starter kit (3 Colori)') {
    //   //     $('.product-picker-option-three').css('display', 'none');
    //   //     $('.single_included_set_main').css('display', 'flex');
    //   //     $('.single_included_set_main').find('[data-product-id]').addClass("product-picker-col-three");
    //   //     $('.product-picker-option-three').find('.product-picker-col-three').removeClass("product-picker-col-three");
          
    //   // }else {
    //   //     $('.product-picker-option-three').css('display', 'flex');
    //   //     $('.single_included_set_main').css('display', 'none');
    //   //     // $('.ps-color-option-three-main').find('.product-picker-col-three').removeClass("product-picker-col-three");
    //   // }

    //   // if(colorOptionlabel === 'Premium kit (4 Colori)' || colorOptionlabel === 'Vanity Kit (5 colori)') {
    //   //   $('.single_included_set_main').find('.product-picker-col-three').removeClass("product-picker-col-three");
    //   //   $('.product-picker-option-three').find('[data-product-id]').addClass("product-picker-col-three");
    //   // }

    //   //   if (colorOptionlabel === '1 Confezione di Gelly' || colorOptionlabel === '2 Confezioni di Gelly' || colorOptionlabel === '3 Confezioni di Gelly') {
    //   //     $('.single_included_set_main').find('.product-picker-col-three').removeClass("product-picker-col-three");
    //   //     $('.ps-color-option-three-main').find('.product-picker-col-three').removeClass("product-picker-col-three");
    //   //   }
        
       
    //     var container = $(".ps-color-option-main .product-picker-option");
    //     container.find(".product-picker-col").remove();
    //     for (var i = 1; i <= colorOptionValue; i++) {
    //       var newCol = `
    //         <div class="product-picker-col" id="Colore${i}" choose_set="${choose_set_option}">
    //           <div class="product-picker">
    //             <span class="product-picker-plus-icon">
    //               <svg class="" width="13" height="13" viewBox="0 0 10 10" fill="none">
    //                 <path d="M5 0.5V9.5M9.5 5H0.5" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"></path>
    //               </svg>
    //             </span>
    //           </div>
    //           <span class="product-option-label">Colore 0`+ i +`</span>
    //         </div>
    //       `;
    //       container.append(newCol);  
    //     }

    //   // var length = $('.ps-color-option-main .product-picker-col').length;
    //   // var lengthPlusOne = length + 1;
    //   // var textToAppend = 'Design 0' + lengthPlusOne;
    //   // $('.product-option-label-two').empty();
    //   // $('.product-option-label-two').append(textToAppend);
      
    //  });
    });

      // var length = $('.ps-color-option-main .product-picker-col').length;
      // var lengthPlusOne = length + 1;
      // var textToAppend = 'Design 0' + lengthPlusOne;
      // $('.product-option-label-two').empty();
      // $('.product-option-label-two').append(textToAppend);



$(document).on('click', '.product-picker-col', function() {
    var selectedLabel = $(this).find('.product-option-label').text();
    var drawar_set_option_in = $('#drawer-content-free').attr('choose_set');

    // Pass the clicked picker to openDrawerTwo
    var picker = $(this).find('.product-picker');
    openDrawerTwo(picker, selectedLabel);

    // Show/hide the choose_set options
    if(drawar_set_option_in === 'choose_set_1') {
        $('.choose_set_option_one').show();
    } else { $('.choose_set_option_one').hide(); }

    if(drawar_set_option_in === 'choose_set_2') {
        $('.choose_set_option_two').show();
    } else { $('.choose_set_option_two').hide(); }

    if(drawar_set_option_in === 'choose_set_3') {
        $('.choose_set_option_three').show();
    } else { $('.choose_set_option_three').hide(); }

    if(drawar_set_option_in === 'choose_set_4') {
        $('.choose_set_option_four').show();
    } else { $('.choose_set_option_four').hide(); }

    if(drawar_set_option_in === 'choose_set_5') {
        $('.choose_set_option_five').show();
    } else { $('.choose_set_option_five').hide(); }

    if(drawar_set_option_in === 'choose_set_6') {
        $('.choose_set_option_six').show();
    } else { $('.choose_set_option_six').hide(); }

    // Store the label if not already set
    if (!$(this).attr('p_text')) {
        $(this).attr('p_text', selectedLabel);
    }
});


$(document).on('click', '.product-picker-col-two', function() {
    var selectedLabel1 = $(this).find('.product-option-label-two').text();
    $('.product-picker-col-two').removeAttr('p_text');
    $(this).attr('p_text', selectedLabel1);  
});

$('.option-picker-col-three').on('click', function() {
    $(this).toggleClass('option-product-selected');
    $(this).toggleClass('product-picker-col-three');
});

// $('.color-option-addtocart-btn').on('click', function() {
//     var choose_set_option1 =  $(this).attr('choose_set');
//     $('#drawer-content-free').attr('choose_set', choose_set_option1);
    
//     var drawar_set_option_in1 = $('#drawer-content-free').attr('choose_set');
  
//     if(drawar_set_option_in1 === 'choose_set_1') {
//         $('.choose_set_option_one').show();
//     }else{
//         $('.choose_set_option_one').hide();
//     }
     
//     if(drawar_set_option_in1 === 'choose_set_2') {
//         $('.choose_set_option_two').show();
//     }else{
//         $('.choose_set_option_two').hide();
//     }
     
//     if(drawar_set_option_in1 === 'choose_set_3') {
//         $('.choose_set_option_three').show();
//     }else{
//         $('.choose_set_option_three').hide();
//     }
     
//     if(drawar_set_option_in1 === 'choose_set_4') {
//         $('.choose_set_option_four').show();
//     }else{
//         $('.choose_set_option_four').hide();
//     }
     
//     if(drawar_set_option_in1 === 'choose_set_5') {
//         $('.choose_set_option_five').show();
//     }else{
//         $('.choose_set_option_five').hide();
//     }
     
//     if(drawar_set_option_in1 === 'choose_set_6') {
//         $('.choose_set_option_six').show();
//     }else{
//         $('.choose_set_option_six').hide();
//     }
  
   
// });


//   let lastScrollTop = 0;
//   const $button = $('#add-options');
//   const $form = $('.ProductForm');
//   const $formHeight = $form.height();
   
//   $(window).scroll(function() {
//     let scrollTop = $(this).scrollTop();
    
//     if (scrollTop > lastScrollTop) {
//         $button.addClass('visible');
//     } else {
//         if (scrollTop === 0 || scrollTop < $formHeight) {
//             $button.removeClass('visible');
//         }
//     }
    
//     if (scrollTop >= $formHeight) {
//         $button.removeClass('visible');
//     }else{
//         $button.addClass('visible');
//         if (scrollTop === 0) {
//                 $button.removeClass('visible');
//         }
//     }
    
//     lastScrollTop = scrollTop;
// });



//  $('#header_cart_link').on('click', function() {
//         var $pageOverlay = $('.PageOverlay');
//         if ($pageOverlay.hasClass('is-visible')) {
//             $pageOverlay.removeClass('is-visible');
//         }
//         $('#sidebar-cart').show();
// });




// function isLaptop() {
//     return window.innerWidth >= 991 && window.innerWidth <= 1199;
// }

// function isTablet() {
//     return window.innerWidth >= 768 && window.innerWidth <= 991;
// }

// function isMobile() {
//     return window.innerWidth <= 768; 
// }

// function updateContentVisibility() {
//     var laptopView = document.querySelector('.product-content-laptop-view');
//     var tabletView = document.querySelector('.product-content-tablet-view');
//     var desktopView = document.querySelector('.product-content-desktop-view');
//     var mobileView = document.querySelector('.product-content-desktop-mobile');

//     if (isLaptop()) {
//         if (desktopView) desktopView.remove();
//         if (tabletView) tabletView.remove();
//         if (mobileView) mobileView.remove();
//         if (laptopView && !laptopView.parentElement) {
//             document.body.appendChild(laptopView);
//         }
//     } else if (isTablet()) {
//         if (desktopView) desktopView.remove();
//         if (laptopView) laptopView.remove();
//         if (mobileView) mobileView.remove();
//         if (tabletView && !tabletView.parentElement) {
//             document.body.appendChild(tabletView);
//         }
//     } else if (isMobile()) {
//         if (desktopView) desktopView.remove();
//         if (laptopView) laptopView.remove();
//         if (tabletView) tabletView.remove();
//         if (mobileView && !mobileView.parentElement) {
//             document.body.appendChild(mobileView);
//         }
//     } else {
//         if (laptopView) laptopView.remove();
//         if (tabletView) tabletView.remove();
//         if (mobileView) mobileView.remove();
//         if (desktopView && !desktopView.parentElement) {
//             document.body.appendChild(desktopView);
//         }
//     }
// }

// // Initial call to set the correct view
// updateContentVisibility();

// // Add event listener for window resize
// window.addEventListener('resize', updateContentVisibility);